<template>
  <div class="lotto_event_wrap trx">
    <div v-show="!endedEvent">
      <div class="lotto_num_list">
      <div class="num_ball" v-for="(lotto, idx) in lottoList" :key="idx" :style="`background:${lotto.color}`" @click="selectObj(lotto)">{{ lotto.num }}</div>
      </div>
      <div class="selected_lotto_list">
        <div class="text">
          <span>내번호</span>
          <span>자동</span>
        </div>
        <div class="list_wrap">
          <div class="selected_ball_list trx">
            <div v-for="(lotto, idx) in 6" :key="idx" :class="selectedList[idx] ? 'num_ball' : 'default'" 
            :style="selectedList[idx]  ? `background:${selectedList[idx].color}` : 'background:#F2F3F6;'"
            @click="selectedList[idx] ? selectObj(selectedList[idx]) : null">
            <template v-if="selectedList[idx]">
              {{ selectedList[idx].num }}
            </template>
            </div>
          </div>
          <img src="images/basic/icon/Group 2 Copy.svg" alt="" @click="randLotto">
        </div>
      </div>
      <div class="apply btn" :class="selectedList.length == 6 && ticketCnt > 0 ? 'submit' : ''" @click="joinEvent">
        <a href="javascript:void(0)" >
          {{ticketCnt > 0 ? '로또 참여하기' : '로또에 참여하기 위해선 참여권이 필요합니다.'}}
        </a>
      </div>
      <template v-if="adEnable">
        <div class="apply btn enable" @click="checkAdType()" >
          <a href="javascript:void(0)" >참여권 받기 ( 2장 )</a>
        </div>
      </template>
      <template v-else>
        <div class="apply btn disable">
          <p><span>{{timeText}}</span> 후 참여권 흭득 가능</p>
        </div>
      </template>
      
      <div class="lotto_today_wrapper">
        <div class="ticket_cnt_info">
            <p class="head">참여할 수록 더해지는<br>참여권 획득 방법</p>
            <div class="ticket_cnt">
              <p>보유 참여권</p>
              <p>{{ticketCnt}}</p>
            </div>
        </div>
        <p class="ad_ticket_info">광고 시청시 2장의 참여권을 지급해요.<br>
          광고 시청시 계속 지급되니 꾸준히 받는게 좋겠죠?
        </p>

        <div class="referee_mission_info">
          <p class="head">로또 시즌25 참여를 위한 필수 미션</p>
          <div class="referee_button" @click="inviteLink('share')">
              <img class="success_ic" src="/images/lotto/mission-success.svg" v-show="refereeMission == 'Y'"/>
              <div class="content">
                <p :class="refereeMission == 'Y' ? 'on':''">친구 추천으로 가입 1회 (처음한번만)</p>
                <img class="referee_ic" :src="refereeMission == 'Y' ? '/images/lotto/referee_btn_ic_off.svg' : '/images/lotto/referee_btn_ic.svg'" />
              </div>
          </div>
        </div>

        <div class="ticket_add_info">
          <p class="head second">일일 미션 달성시<br>참여권 추가 5개 지급!</p>
		<div class="ticket_add" v-show="todayMission=='N' & dailyCheck=='Y' & adCntCheck=='Y' & commentCheck=='Y'" @click="reqeustMissionTicket()">
            <p>추가 5장 받기</p>
          </div>
        </div>
        <div class="mission_item_wrapper">
          <div class="mission_item">
            <img class="success_ic" src="/images/lotto/mission-success.svg" v-show="dailyCheck == 'Y'"/>
            <div class="item_info">
              <img class="attendtion_ic" :src="dailyCheck == 'Y' ? '/images/lotto/attendtion-check-on.svg' :'/images/lotto/attendtion-check.svg'">
              <p :class="dailyCheck == 'Y' ? 'on':''">출석체크</p>
            </div>
          </div>
          <div class="mission_item">
            <img class="success_ic" src="/images/lotto/mission-success.svg" v-show="commentCheck == 'Y'"/>
            <div class="item_info">
              
              <img class="attendtion_ic" :src="commentCheck == 'Y' ? '/images/lotto/reply-on.svg' :'/images/lotto/reply.svg'">
              <p :class="commentCheck == 'Y' ? 'on':''">전문가방 or<br>코인톡 댓글</p>
            </div>
          </div>
          <div class="mission_item">
            <img class="success_ic" src="/images/lotto/mission-success.svg" v-show="adCntCheck == 'Y'"/>
            <div class="item_info">
              <img class="attendtion_ic" :src="adCntCheck == 'Y' ? '/images/lotto/ad-on.svg' :'/images/lotto/ad.svg'">
              <p :class="adCntCheck == 'Y' ? 'on':''">채굴 광고<br>5회이상 시청</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="endedEvent">
      <p>이벤트가 종료되었습니다.</p>
    </div>
  </div>
</template>

<script>
import { fetchInfomation, fetchAdCheck, adTypeCheck, requestCreate, fetchTicket, requestUse, fetchJoinList, fetchWinnerInfo, requestMission } from '@/api/ngame'

export default {
  data() {
    return {
      randColorList: ['#FBC400', '#6AC7F1', '#FF7170', '#A7A2E0', '#6DCE9D'],
      lottoList: [],
      lottoRequest: false,
      adEnable: false,
      nextAdTime: 0,
      ticketCnt: 0,
      timeText:"00:00:00",
      second:0,
      requested:false,
      requestedAdType:false,
      endedEvent:false
    }
  },
  props: {
    accountCoin: {
      type: String
    },
    todayMission: {
      type: String
    },
    dailyCheck: {
      type: String
    },
    adCntCheck: {
      type: String
    },
    commentCheck: {
      type: String
    },
    refereeMission: {
      type: String
    },
    openDate: {
      type: String
    },
    openTime: {
      type: String
    },
    endDate: {
      type: String
    },
    endTime: {
      type: String
    },
  },
  watch : {
    'endDate': function(){
      var dt = new Date();
      var end_dt = new Date(this.endDate.replace(/-/g, "/") +" "+ this.endTime);
      if(end_dt < dt){
        this.endedEvent = true;
      }
    }
  },
  computed: {
    selectedList() {
      return this.lottoList.filter(lotto => lotto.selected);
    }
  },
  created() {
    window.VueRoot=this;
    this.adTimeCheck();
    this.getTicketCnt();
  },
  mounted() {
    var lotto_cnt = 45; // 생성할 로또 갯수
    for(var i=0 ; i<lotto_cnt ; i++){
      var lotto = new Object();
      lotto.num = i+1;
      lotto.color = '#e6e9ec'
      lotto.selected = false;
      this.lottoList.push(lotto);
    }
  },
  destroyed() {
     clearInterval(this.interval);
  },
  methods: {
    selectObj(target) {
      var color = '#e6e9ec' // default gray(un selected)
      if(!target.selected){
        color = this.randColorList[parseInt((target.num-1)/10)]
      }
      target.selected = !target.selected;
      target.color = color;
      var selected_array = this.selectedList;
      if(selected_array.length > 6){
        target.selected = !target.selected;
        target.color = '#e6e9ec';
      }
    },
    selectNum(idx, num) {
      if(this.selectedList.some((item) => item.num == num)) {
           this.selectedList.forEach((el, i) => {
           if(el.num == num) {
             this.selectedList.splice(i, 1);
             this.lottoList[idx].color = '#e6e9ec'
           }
         })
      } else if(this.selectedList.length < 6) {
         const randNum = Math.floor(Math.random() * (this.randColorList.length));
         const color = this.randColorList[randNum];
         this.lottoList[idx].color = color
         this.selectedList.push({ color, num })
      }
    },
    randLotto() {
      this.refreshLottoList();
      while( this.selectedList.length < 6){
        const randNum = Math.floor(Math.random() * (this.lottoList.length));
        const color = this.randColorList[parseInt((randNum)/10)]
        var r_lotto = this.lottoList[randNum];
        r_lotto.selected = true
        r_lotto.color = color
      }
    },
    refreshLottoList() {
      this.lottoList.forEach(lotto =>{
        lotto.color = '#e6e9ec';
        lotto.selected = false;
      })
    },
    adTimeCheck(){
      fetchAdCheck({
      }).then(({ data }) => {
        this.nextAdTime = data.nextAdTime;
        this.adEnable = data.nextAdTime <= 0;
        this.second = data.nextAdTime;
        if(this.second>0){
              this.uiSetTimeText(); 
           }
      })
    },
    checkAdType(){
      if(this.isEnvalidEventDateTime()){
        alert("참여할 수 없는 시간입니다.");
        return;
      }
      if(this.requestedAdType) return;
      this.requestedAdType = true;
      adTypeCheck({
      }).then(({ data }) => {
        var adType = "adNormal";
        try{
          adType = data.adType;
        }catch(e){
          console.log(e);
        }
        this.startNativeAd(adType);
      })
    },
    getTicketCnt(){
      fetchTicket({ 
      }).then(({ data }) => {
        this.ticketCnt = data.ticketInfo.ticketCnt;
      })
    },
    addTicketCnt(){
      this.requestedAdType = false;
      requestCreate({ 
      }).then(({ data }) => {
        if(data.resultCode == 3501){
          alert("추천 후 참여가능 합니다.");
        }
        this.adTimeCheck();
        this.getTicketCnt();
      })
    },
    joinEvent() {      
      if(this.isEnvalidEventDateTime()){
        alert("참여할 수 없는 시간입니다.");
        return;
      }
      if(this.ticketCnt == 0){
        alert('이벤트 참여권이 부족합니다.')
        return;
      }
      if(this.selectedList.length != 6){
        alert('번호선택 후 참여가능합니다.')
        return;
      }
      var str = '';
      this.selectedList.forEach(el => {
        str += el.num + ','
      })
      var selectNumberList = str.slice(0, -1)

      if(this.lottoRequest) return;
      this.lottoRequest = true;

      requestUse({
        eventId: this.$route.query.eventId,
        selectNumberList 
      })
      .then(({ data }) => {
        this.lottoRequest = false;
        if(data.resultCode == 1000) {
          alert('참여되었습니다.')
          this.refreshLottoList();
          this.$parent.fetchData();
        }else if(data.resultCode == 3500){
          alert('이벤트 참여권이 부족합니다.');
          this.$parent.fetchData();
        }else if(data.resultCode == 3501){
          alert('추천 후 참여가능합니다.');
          this.$parent.fetchData();
        }else if(data.resultCode == 2100){
          alert('이벤트 참여에 실패했습니다.\n잠시후 다시 시도해주세요.');
          this.$parent.fetchData();
        }
        this.getTicketCnt();
      })
    },
    startNativeAd( adType ){
      var varUA = navigator.userAgent.toLowerCase();
      if ( varUA.indexOf('android') > -1) {
        //ANDROID
        try{
          window.Android.platInterstitialAd(adType);
          //window.Android.platInterstitialAd("adNative"); // native ad 만 load
        }catch(e){
          console.log(e);
        }
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
          window.webkit.messageHandlers.platInterstitialAd.postMessage(adType);
      } else {
          //아이폰, 안드로이드 외
          //playSpin();
      }
    },
    uiSetTimeText(){
      clearInterval(this.interval);
      this.interval = setInterval(function(){
	      window.VueRoot.second--;
        var sec_num = window.VueRoot.second; // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        var timeTextStr = hours+":"+minutes+":"+seconds;
        window.VueRoot.timeText = timeTextStr;
        if(sec_num < 0) {
           clearInterval(window.VueRoot.interval);
           window.VueRoot.adTimeCheck();
        }
	    },1000);
    },
    reqeustMissionTicket(){
      /*
      if(this.refereeMission != "Y"){
        alert("추천 후 참여가능 합니다.");
        return;
      }
      */
     if(this.isEnvalidEventDateTime()){
        alert("참여할 수 없는 시간입니다.");
        return;
      }
      if(this.requested)return;
      this.requested = true;
      requestMission({ 
      }).then(({ data }) => {
        this.requested = false;
        if(data.resultCode == 1000){
          alert("미션 참여권이 지급되었습니다.");
        }else if(data.resultCode == 3500){
          alert("미션을 완료해주세요.");
        }else if(data.resultCode == 3501){
          alert("추천 후 참여가능 합니다.");
        }else{
          alert("미션 참여권 지급에 실패했습니다.\n잠시후 다시 시도해주세요.");
        }
        this.getTicketCnt();
        this.$parent.fetchData();
      })
    },
    inviteLink(target){
      if(this.refereeMission == 'Y') return;
      var varUA = navigator.userAgent.toLowerCase();
      if ( varUA.indexOf('android') > -1) {
          //ANDDROID
          try{
            window.Android.inviteLink(target);
          }catch (error){
            console.log(error);
          }
      } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
          //IOS
          try{
            window.webkit.messageHandlers.inviteLink.postMessage(target);
          }catch (error){
            console.log(error);
          }
      } else {
          //아이폰, 안드로이드 외 
      }
    },
    /**
     * return 1(true): 참여 불가능한 시간 , 0(false): 참여 가능한 시간
     */
    isEnvalidEventDateTime(){
      var dt = new Date();
      var open_dt = new Date(this.openDate.replace(/-/g, "/") +" "+ this.openTime);
      var end_dt = new Date(this.endDate.replace(/-/g, "/") +" "+ this.endTime);
      return dt < open_dt | end_dt < dt;
    },
  },
}
</script>

<style scoped>


</style>
